import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Table from 'antd/lib/table';
import Select, { Option } from 'antd/lib/select';
import { Modal } from 'antd';
import Button from 'antd/lib/button';
import TextArea from 'antd/lib/input';
import Icon from 'antd/lib/icon';

import tmpColumns from './BookingsTableColumns';
import { bookingStatuses } from '../../config';

const propTypes = {
  rows: PropTypes.array,
  pageSize: PropTypes.number,
  current: PropTypes.number,
  total: PropTypes.number,
  refresh: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
};

const defaultProps = {
  rows: [],
  pageSize: 10,
  current: 1,
  total: 0,
};

class BookingsTable extends PureComponent {
  state = {
    dialog: false,
  };

  showNotesDialog = (id, notes) => {
    this.setState({
      dialog: { id, notes: notes || '' },
    });
  };
  closeDialog = () => {
    this.setState({
      dialog: false,
    });
    this.props.refresh();
  };

  changeNotes = e => {
    this.setState({
      dialog: {
        ...this.state.dialog,
        notes: e.target.value,
      },
    });
  };

  save = async () => {
    await fetch('/admin/set-booking-notes', {
      method: 'post',
      body: {
        id: this.state.dialog.id,
        text: this.state.dialog.notes,
      },
      credentials: 'include',
    });
    this.closeDialog();
  };

  render() {
    const { rows, pageSize, current, total } = this.props;
    const { onPageChange, onPageSizeChange, onStatusChange } = this.props;
    const columns = _.map(tmpColumns, col => {
      switch (col.dataIndex) {
        case 'BookingStatus':
          return {
            ...col,
            render: (value, record) => (
              <Select
                value={_.find(bookingStatuses, ['id', value]).name}
                onSelect={v => {
                  onStatusChange(record.BookingID, v);
                }}
              >
                {_.map(bookingStatuses, status => (
                  <Option
                    key={status.id}
                    title={status.name || ''}
                    value={`${status.id}`}
                    disabled={status.id <= value}
                  >
                    {status.name}
                  </Option>
                ))}
              </Select>
            ),
          };
        case 'notes':
          return {
            ...col,
            render: (val, record) => (
              <div
                style={{
                  width: '100%',
                  cursor: 'pointer',
                }}
                onClick={() => this.showNotesDialog(record.BookingID, val)}
              >
                {val || <Icon type="edit" style={{ fontSize: 16 }} />}
              </div>
            ),
          };
        default:
          return col;
      }
    });
    return (
      <div>
        <Table
          scroll={{ x: '4000px', y: 'calc(100vh - 334px)' }}
          dataSource={rows}
          rowKey="BookingID"
          columns={columns}
          pagination={{
            onChange: onPageChange,
            pageSize,
            current,
            total,
            showSizeChanger: true,
            onShowSizeChange: onPageSizeChange,
          }}
        />
        <Modal
          visible={!!this.state.dialog}
          title={`Set notes for booking ${this.state.dialog.id}`}
          onCancel={this.closeDialog}
          footer={[
            <Button
              key="cancel"
              type="primary"
              size="large"
              onClick={this.closeDialog}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              size="large"
              onClick={this.save}
            >
              Save
            </Button>,
          ]}
        >
          <TextArea
            value={this.state.dialog.notes}
            onChange={this.changeNotes}
          />
        </Modal>
      </div>
    );
  }
}

BookingsTable.propTypes = propTypes;
BookingsTable.defaultProps = defaultProps;

export default BookingsTable;
